import React from 'react';
import { motion } from 'framer-motion';
interface PhoneMockupProps {
  children: React.ReactNode;
  className?: string;
  glowColor?: 'green' | 'red' | 'none';
  floating?: boolean;
  delay?: number;
}
export function PhoneMockup({
  children,
  className = '',
  glowColor = 'none',
  floating = false,
  delay = 0
}: PhoneMockupProps) {
  const glowClass = glowColor === 'green' ? 'shadow-[0_0_60px_-15px_rgba(68,198,87,0.3)]' : glowColor === 'red' ? 'shadow-[0_0_60px_-15px_rgba(194,52,52,0.3)]' : 'shadow-2xl';
  const floatingAnimation = floating ? {
    y: [0, -15, 0],
    transition: {
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: delay
    }
  } : {};
  return <motion.div className={`relative w-[280px] h-[580px] rounded-[48px] border-[8px] border-[#1A1A1D] bg-ascension-black overflow-hidden flex flex-col ${glowClass} ${className}`} animate={floatingAnimation} data-id="element-166">
      {/* Dynamic Island / Notch */}
      <div className="absolute top-0 inset-x-0 h-6 flex justify-center z-20" data-id="element-167">
        <div className="w-24 h-6 bg-[#1A1A1D] rounded-b-2xl" data-id="element-168"></div>
      </div>

      {/* Screen Content */}
      <div className="flex-1 w-full h-full relative z-10 pt-8 pb-6 px-4 flex flex-col" data-id="element-169">
        {children}
      </div>

      {/* Home Indicator */}
      <div className="absolute bottom-2 inset-x-0 flex justify-center z-20" data-id="element-170">
        <div className="w-24 h-1 bg-white/20 rounded-full" data-id="element-171"></div>
      </div>
    </motion.div>;
}